var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#F38A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22266 3.1636L6.54589 7.58192C6.54589 7.86151 6.7075 8.0013 7.03074 8.0013H8.97013C9.29336 8.0013 9.45498 7.86151 9.45498 7.58192L9.77821 3.1636C9.77821 3.0111 9.72434 2.89672 9.6166 2.82047C9.53579 2.7188 9.42804 2.66797 9.29336 2.66797H6.70751C6.57282 2.66797 6.45161 2.7188 6.34387 2.82047C6.26306 2.89672 6.22266 3.0111 6.22266 3.1636Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00043 9.78027C8.48997 9.78027 8.9022 9.96063 9.23715 10.3213C9.59786 10.6563 9.77821 11.0685 9.77821 11.5581C9.77821 12.0476 9.59786 12.4727 9.23715 12.8334C8.9022 13.1684 8.48997 13.3358 8.00043 13.3358C7.5109 13.3358 7.08578 13.1684 6.72507 12.8334C6.39013 12.4727 6.22266 12.0476 6.22266 11.5581C6.22266 11.0685 6.39013 10.6563 6.72507 10.3213C7.08578 9.96063 7.5109 9.78027 8.00043 9.78027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.c8c9cea2b6804628d462b85dbf2eb66a.svg";
export { ForwardRef as ReactComponent };